<template>
	<div class="w-100">
		<div>
	    <div class="w-16px rounded border-2-green text-center delay mt-2px mr-2 d-inline-block position-relative cursor-pointer" :class="{'bg-green':local_item.is_checked}" @click="toggleCheck">
	     <img src="../../../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -7px" v-if="local_item.is_checked">
	    </div>
	    <p class="mb-0 body-2-2 font-regular position-absolute d-inline-block cursor-pointer" :class="{'text-green':local_item.active}" @click="toggleCheck">{{local_item.data.name}}</p> 
	  </div>
	  <div class="d-block mt-2" v-if="local_item.is_checked">
	    <p class="mb-0 bg-white body-2 text-14 font-regular px-1 delay label-active text-black">{{local_item.data.name}} <span class="text-lowercase">{{$t("restaurant.note")}}</span></p>
	    <input type="input" @input="sendBack" class="form-control body-2-2 font-semibold text-14 mb-1" v-model="local_item.note">
	  </div>
	</div>
</template>
<script>
	export default {
		props:['item','index'],
		data(){
      return{
        local_item: {}
      }
    },
    created(){
      this.local_item = JSON.parse(JSON.stringify(this.item))
    },
    methods:{
      toggleCheck(){
        this.local_item.is_checked = !this.local_item.is_checked
        this.local_item.note = (this.local_item.is_checked === false) ? '' : this.local_item.note
        this.sendBack()
      },
      sendBack(){
        this.$emit("submit",{
          data: this.local_item,
          index: this.index.index
        })
      }
    }
	} 
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/desktop/specialRequestItem.vue